<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 p-0">
        <TableHPReportOverview
          :current-project="getCurrentProject"
          :key="projectId"
          :projects-list="getProjects"
          @changeProject="getProjectPage($event)"
          v-if="getCurrentProject"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TableHPReportOverview from '@components/tables/TableHPReportOverview'

export default {
  components: {
    TableHPReportOverview
  },
  data () {
    return {
      projectId: 1,
      currentProject: null
    }
  },
  created () {
    if (!this.getProjects.length) {
      this.$api.projects.getProjects()
    }
    this.projectId = this.$route.params.id
    this.$watch(
      () => this.$route.params,
      (toParams) => {
        this.projectId = toParams.id
        this.$forceUpdate()
      }
    )
  },
  computed: {
    ...mapGetters({
      getProjects: 'projects/getProjects'
    }),
    getCurrentProject () {
      return this.getProjects.find(project => true)
    }
  },
  methods: {
    getProjectPage (data) {
      this.$router.push({ name: 'h-p-report', params: { id: data.id } })
      this.projectId = data.id
    }
  }
}
</script>

<style lang="scss" scoped>
.multiselect-projects {
  width: 200px;
}
</style>
